import { render, staticRenderFns } from "./Thrills.vue?vue&type=template&id=4de3353b&"
import script from "./Thrills.vue?vue&type=script&lang=js&"
export * from "./Thrills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports